import React from 'react';
import PlainTicketFooter from '../plain-ticket/PlainTicketFooter';
import PlainTicketHeader from '../plain-ticket/PlainTicketHeader';
import PlainTicketSelections from '../plain-ticket/PlainTicketSelections';

function PlainTicket(props) {
	const ticketData = props.ticketData;
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; // TODO: add "isEstero" in configuration
	const isCashout = props.isCashout;
	const terminalCopy = props.terminalCopy;
	const printAgainTerminalRec = props.printAgainTerminalRec;
	const skinProperties = props.skinProperties;
	const user = props.user;
	const conf = props.conf;
		
	return <div id={"ticket-" + ticketData.idTicket} className="ticket-container">
        <PlainTicketHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} conf={conf} user={user} skinProperties={skinProperties} printAgainTerminalRec={printAgainTerminalRec} terminalCopy={terminalCopy} isCashout={isCashout} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
        <PlainTicketSelections conf={conf} user={user} skinProperties={skinProperties} printAgainTerminalRec={printAgainTerminalRec} terminalCopy={terminalCopy} isCashout={isCashout} ticketData={ticketData} psvVincPiazzSports={props.psvVincPiazzSports} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
        <PlainTicketFooter aamsLogo={props.aamsLogo} conf={conf} user={user} skinProperties={skinProperties} printAgainTerminalRec={printAgainTerminalRec} terminalCopy={terminalCopy} isCashout={isCashout} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} footerImage={props.footerImage} />
	</div>	
}

export default PlainTicket;